module.exports = __webpack_public_path__ + "944b4f8c7fbd8a2ec4eabdc640e544c1.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/social-media-icons/pinterest.png
// module id = 3002
// module chunks = 0